
import { api } from "./axios";
export const tokenApi = {
    create: (data: any) => api.post("/token/create", data),
    getAll: () => api.get("/token/all-tokens"),
    delete: (id: string) => api.delete(`/token/delete/${id}`),
    update:(id:string , data:any) => api.put(`/token/update/${id}`, data),
}

